import React from 'react'
import axios from 'axios'

export default class MailingListForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            firstname: '',
            lastname: '',
            email: ''
        }

        props.fieldKey ? this.state[props.fieldKey] = props.fieldValue : null

        this.valueUpdater = this.valueUpdater.bind(this)
    }

    valueUpdater = field => (event) => {
      let value = event.target.value;
      const newState = {
        ...this.state,
        [field]: value,
      };

      this.setState(newState);
    }

    sendForm() {
        const { zap } = this.props || null
        if (zap) {
            axios.post(url, JSON.stringify(this.state)).then( res => {

            })
        }
    }

    sendForm() {
        const { zapierUrl } = this.props || null
        if (zapierUrl) {
            if (this.state.email != '' && this.state.firstname != '' && this.state.lastname ) {
                axios.post(zapierUrl, JSON.stringify(this.state)).then( res => {
                    if (res.data.status == 'success') {
                        this.refs.mailerForm.style.display = 'none'
                        this.refs.success.style.display = 'block'
                        this.refs.successMessage.style.display = 'block'
                        this.refs.required.style.display = 'none'
                        this.refs.error.style.display = 'none'
                        typeof ORIBI !== 'undefined' ? ORIBI.api('setUserEmail', this.state.email) : null
                    }
                    else {
                        this.refs.error.style.display = 'block'
                    }
                })
            }
            else {
                this.refs.required.style.display = 'block'
                this.refs.reqMessage.style.display = 'block'
            }
        }
    }
    render() {
        const { title, description, style } = this.props
        return(
            <div className="mailing-form" style={ style }>
                <div className="inner-form">
                    <h3 className="h3">{ title }</h3>
                    <p>{ description }</p>
                    <form ref="mailerForm">
                        <input value={ this.state.firstName } onChange={this.valueUpdater('firstname')} type="text" name="fName" placeholder="First Name*" />
                        <input value={ this.state.lastName } onChange={this.valueUpdater('lastname')} type="text" name="lName" placeholder="Last Name*" /><br />
                        <input value={ this.state.email } onChange={this.valueUpdater('email')} type="email" name="email" placeholder="Email Address*" /><br />
                        <div className="select-option">
                            <select name="subscriber-category" onChange={this.valueUpdater('subscriber-category')}>
                                <option value="">I am a: </option>
                                <option value="parent">Parent</option>
                                <option value="educator">Educator</option>
                                <option value="donor">Donor</option>
                                <option value="application">Application</option>
                                <option value="none">None of the above</option>
                            </select>
                        </div>
                        <div className="check-option">
                            <input onChange={this.valueUpdater('subscribed') } type="checkbox" name="subscribed" value="subscribed" />
                            <label>* I would like to subscribe to the Global Citizen Year newsletter to receive news and updates.</label>
                        </div>
                        <div id="button---submit" className="button src-components-Shared-Signup----Signup-module---Button---1wydx" onClick={ () => { this.sendForm() }}>Submit
                            <svg width="21px" height="10px" viewBox="0 0 21 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                                    <g id="GCY---request-info-form-@2x-updated-Copy-4" transform="translate(-286.000000, -769.000000)" stroke="#222222" strokeWidth="1.5">
                                        <g id="request-info">
                                            <g id="button---submit" transform="translate(193.000000, 743.000000)">
                                                <g id="Group-9" transform="translate(94.000000, 27.000000)">
                                                    <polyline id="Line-2" points="15 0 19 4 15 8"></polyline>
                                                    <path d="M0,4 L18,4" id="Line-3"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </form>
                    <div ref="required" style={{ display: 'none', marginTop:'10px' }}>
                        <p ref="reqMessage" style={{ color: 'red' }}>* Please fill out all required fields</p>
                    </div>
                    <div ref="success" style={{ display: 'none', marginTop:'10px' }}>
                        <p ref="successMessage">Thank you for signing up for our newsletter. You will be hearing from us shortly!</p>
                    </div>
                    <div ref="error" style={{ display: 'none', marginTop:'10px' }}>
                        <p style={{ color: 'red' }}>Something went wrong with your sumbission. Please try again!</p>
                    </div>
                </div>
            </div>
        )
    }


}



// WEBPACK FOOTER //
// ./src/components/Shared/MailingListForm/index.js